import { HttpHandler } from 'msw'

import { refills } from './refills'
import { refunds } from './refunds'
import { sales } from './sales'

export const transactions: HttpHandler[] = [...refills, ...refunds, ...sales]
